// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 300px;
  width: 300px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  outline: none;
  padding-top: 20px;
  text-align: center; }
  .confirmation-modal button {
    cursor: pointer;
    color: #4330ff;
    width: 50%;
    border: none;
    background-color: white; }
    .confirmation-modal button a {
      text-decoration: none;
      color: #2d7cbf !important; }
`, "",{"version":3,"sources":["webpack://./src/components/SettingsAndSupport/modalStyles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB,EAAE;EACpB;IACE,eAAe;IACf,cAAc;IACd,UAAU;IACV,YAAY;IACZ,uBAAuB,EAAE;IACzB;MACE,qBAAqB;MACrB,yBAAyB,EAAE","sourcesContent":[".confirmation-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  height: 300px;\n  width: 300px;\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  outline: none;\n  padding-top: 20px;\n  text-align: center; }\n  .confirmation-modal button {\n    cursor: pointer;\n    color: #4330ff;\n    width: 50%;\n    border: none;\n    background-color: white; }\n    .confirmation-modal button a {\n      text-decoration: none;\n      color: #2d7cbf !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
